<div class="row">
    <div class="col-md-12">
      <div class="d-flex" style="align-items: center">
        <h3 class="TripHeader">
          Margin: {{ margin | currency : "$" : "symbol" : "2.2-4" }} ({{ marginPercent | number : '1.2-2' }}%)
        </h3>
      </div>
    </div>
  </div>
  <hr />
  